// src/project/data/triggers/createWithdrawalAccount.js
import { buildActionUrl, getUserId, getRiderId } from '../config/apiConfig'

export default {
  postUrl() {
    return buildActionUrl('/accounts/create?service=rapidoo')
  },
  async format(payload = {}) {
    const userId = getRiderId() || getUserId()
    let cleanPhone = String(payload.phoneNumber || '').replace(/\+/g, '').replace(/\s+/g, '').trim()
    if (cleanPhone.startsWith('229') && cleanPhone.length > 8) {
      // already has 229 prefix
    } else {
      cleanPhone = `229${cleanPhone}`
    }

    return {
      accountLabel: payload.accountLabel || payload.owner || 'Mon compte de retrait',
      accountIsPhone: true,
      accountNumber: cleanPhone,
      operator: (payload.operator || 'MTN').toUpperCase(),
      country: payload.country || 'BJ',
      userId: userId,
    }
  },
  parse(raw = {}) {
    const statusCode = raw?.statusCode

    if (statusCode === 200 || statusCode === 201) {
      return {
        statusCode: 200,
        message: raw?.message || 'Compte de retrait créé avec succès',
        data: raw?.data || {},
      }
    }

    if (statusCode === 404) {
      return {
        statusCode: 404,
        message: "Ce numéro ne peut pas être utilisé comme compte de retrait. Vérifiez le numéro et l'opérateur.",
        data: null,
      }
    }

    if (statusCode === 409) {
      return {
        statusCode: 409,
        message: "Ce compte Mobile Money est déjà enregistré et validé.",
        data: null,
      }
    }

    return {
      statusCode: statusCode || 400,
      message: raw?.message || 'Erreur lors de la création du compte',
      data: null,
    }
  },
}
